 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"90d3d6adf5de87d26efa","1":"3f9f4c56306eabbad2c6","2":"dd1aaec6511715182b50","3":"abf4e09ffe6db18f57d9","4":"36ef89608db377800969","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"2662ae54dcbac089a132","vendors~Comment~Survey":"7621e12a03c9527e1d2f","vendors~Comment~LoginDialog":"8109350ad2b61f3d7204","Comment":"2f7194768bbfba5c2fa2","vendors~Player":"1ad247d61a4adb8720fd","AccountOpening":"74da39f02c54a5962a94","BackTopBottom":"ab84a614d15c318b0667","Caption":"57bb5587eb791d6ba9c6","Copyright":"e93c50442a9fa6b0f07c","DataBox":"b3b86f76c3246b85cdf8","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"dfb756ed7c633f1490e7","Nav":"e2cf46ef7a11866c56bb","NormalCaption":"ab0e7da54e62906e5274","Offline":"c80e34c623cc5f70e704","QQShare":"049a54985c5a0a206793","Stick":"d26b8b9a45a20e833235","Tip":"fd2023d2e396e68d27f7","ViewMoreLink":"808baee28046412491d4","WxLaunchApp":"58d791a69261c8e2557e","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"8d0e185c6e7c8464e0d5","Atlas":"450ae0fe72ad610514de","FiveNavPic":"69206c35f06f4561d850","FourNavPic":"1eccfba19e1e56cc7eff","vendors~MdBanner":"4e5696d697a1cc2c5e29","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"747338c76094aaee8557","CallupVideoAppHead":"f1c2f8cce2fa432dc8b7","HomeFooter":"ce9f8dede96f00984282","Hongbao":"bde664dbed5bce90a948","TwoImage":"d856ad0c278736f7d9bb","ThreeNavPic":"7ae5243543c590cad50b","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"61b82321799f753e0b11","BigImage":"6777673f02f75c3e07ad","NoImage":"f767868bd67946a23566","OneImage":"b52a7c149ac70503fb8d","ThreeImage":"aabaff668c68905377a7","vendors~NewsStream":"55557624707ee716b14a","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"ac9701c05edb4e84b120","BigImg":"d7268e094cd2fd66f371","SingleTitle":"9819ed61e023f75e87bc","SlideImg":"9f2fcfa3dde8d53484bc","TwoImg":"8ecb229b474335037c0c","vendors~BigTopic~InformationFlow~TitleImg":"b721d3f7a40e742c2332","InformationFlow":"b2b465d952e692777f75","BigTopic":"cf678a7f1bcf595bb76d","TitleImg":"12e55348a4016e827b8c","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"3008d65ff0759134d3b8","NormalSlides":"ac525cf20f89932e46a8","ShareSlides":"d2338d866022c7cef684","vendors~BottomSlides~UpgradeBottomSlides":"30e6a5171f2c52a4ce2e","UpgradeBottomSlides":"da168d3231b3ea5e4e21","vendors~IndexSlides":"6b151f82417c9e32e7ef","vendors~BrowserGuideLayer":"082a74c1bd73fed6d6fb","vendors~CallupHead":"d9c8fc5fcaa445f49bfb","vendors~ShareComment":"b5204a1bd9a2a2407595","vendors~Survey":"4dd409de4ecb7ffa0883","vendors~NormalTabs":"73d71a2d5f0ad40c77a8","vendors~WXGuideLayer":"07afec9cef08d1c64319","LoginDialog":"94396db2ed550aea9fb1","vendors~MarkTabs":"d1924562c5e58a24f05c","vendors~SimpleGuideLayer":"c84f3f354fe5a8fc2977","vendors~SlidesTabs":"0d63bba037cda67490b4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
